export default __webpack_public_path__ + "static/media/small-close.038e4eec.svg";